module.exports = __webpack_public_path__ + "img/btn_bg_sound_on.a1a5a7fd.svg";